import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { FormGroup, Button, Col, Row, FormControl, Checkbox, ControlLabel} from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import DocumentsService from "../../../services/DocumentsService";
import HandleError from "../../../services/HandleError";
import LoaderInline from "../../helpers/LoaderInline";
import InlineError from "../../messages/InlineError";

class DocumentsCreateForm extends Component {

    state = {
    	saveDocumentLoading: false,
    	selectedFile: null,
    	uploadFile: false,
    	formData:{},
    	errors: {}
    }

	onChange = (e) => { this.setState({ formData: {...this.state.formData, [e.target.name]: e.target.value} }); }

	onCheckboxChange = (e) => {
    	this.setState({...this.state, uploadFile: e.target.checked, formData: {...this.state.formData, [e.target.name]: e.target.checked} });
	}
	
	onFileUpload = () => { 
		const { selectedFile } = this.state;
		if (selectedFile && selectedFile.name) {
			const formdata = new FormData();
			formdata.append("file", selectedFile, selectedFile.name);
			this.setState({isUploading:true});
			new DocumentsService(this,"/upload-file").store(formdata, true).then((res) => {
				this.setState({ isUploading: false, selectedFile: null, errors:{} });
				NotificationManager.success("File uploaded.","Success!");
			}).catch((err) => {
				HandleError(err, this);
				this.setState({ isUploading: false, selectedFile: null, errors:{} });
			});
		}
	}
	
	onSubmit = (e) => {
		e.preventDefault();
		this.setState({saveDocumentLoading: true, errors: {}});
		this.documentService.store(this.state.formData).then((res) => {
			this.setState({saveDocumentLoading: false});
			NotificationManager.success("Document created.","Success!");
			this.props.history.push("/documents");	 
		}).catch((err) => {
			this.setState({saveDocumentLoading: false});
			HandleError(err, this);
		});
	}

	handleFilePicker = (e) => {
		this.setState({ 
			selectedFile: e.target.files[0] 
		}, () => {
			this.onFileUpload();
		});
	}

 
	documentService = new DocumentsService(this);

	render() {
		const { saveDocumentLoading, formData, errors, uploadFile } = this.state;
 
		return (
    		<React.Fragment>
    			<Row>
					<form onSubmit={this.onSubmit}>
    					<Col md={4} sm={12}>
							<span className="column-title">Document details</span>

							<FormGroup validationState={errors.name && "error"}>
								<ControlLabel>Name</ControlLabel>                                  
								<FormControl type="text" name="name" placeholder="Enter name" value={formData.name || ""} onChange={this.onChange}/>						
								{errors.name && <InlineError text={errors.name} />}								                                							
							</FormGroup>

							<FormGroup validationState={errors.link && "error"}>
								<ControlLabel>Link</ControlLabel>                                  
								<FormControl type="text" name="link" placeholder="Enter link" value={formData.link || ""} disabled={uploadFile} onChange={this.onChange}/>						
								{errors.link && <InlineError text={errors.link} />}								                                							
							</FormGroup>
                           
							{/* <FormGroup validationState={errors.direct_logging && "error"}>
								<Checkbox name="uploadFile" inline onChange={this.onCheckboxChange} checked={uploadFile}>
									Upload file
								</Checkbox> 
							</FormGroup>

							{uploadFile && 
								<FormGroup controlId="fileController" className="doc-file-upload" validationState={errors.file && "error"}>
									<ControlLabel>File</ControlLabel>  
									<FormControl type="file" onChange={this.handleFilePicker} />
									<label htmlFor="fileController" className="file-uploade-label">
										<span className="file-uploader-bg" >
											<b>{(this.state.selectedFile && this.state.selectedFile.name) ? this.state.selectedFile.name : "Choose File"}</b>
										</span>
									</label>
									{errors.file && <InlineError text={errors.file} />}
								</FormGroup>
							}
                            */}					
							<Button className="btn-crud" bsStyle="primary" disabled={saveDocumentLoading} type="submit">{saveDocumentLoading?"Saving...":"Save"}</Button> 
							{ saveDocumentLoading ? <LoaderInline width="30" height="30" color="#2196f3"/> :  null }																												
    					</Col>	
					</form>						
    			</Row>
    		</React.Fragment>
    	);
	}
}
DocumentsCreateForm.propTypes = {
	history: PropTypes.shape({
		push: PropTypes.func.isRequired
	}).isRequired
};
export default DocumentsCreateForm;


// WEBPACK FOOTER //
// ./src/components/forms/documents/DocumentsCreateForm.js